import { connectHits } from 'instantsearch.js/es/connectors';
import { autop } from '@wordpress/autop';

// create the render function
const renderHits = (renderOptions) => {
    const { hits, widgetParams } = renderOptions;

    widgetParams.container.innerHTML = `
        ${hits.map((item) => `
            <article>
                <a
                    href="${item.url}"
                    class="group flex flex-col relative h-full pb-20 md:pb-36 px-8 border bg-white rounded-xl overflow-hidden text-left">
                    ${item.image ? `
                        <div class="relative mb-8 -mx-8 after:block after:pb-9/16">
                            <img
                                src="${item.image}"
                                class="absolute w-full h-full object-cover object-${item.listing.position}">
                        </div>
                    ` : ''}
                    <h3 class="mb-2.5 text-xl font-semibold">${item.title}</h3>
                    ${autop(item.excerpt)}
                    <div class="flex items-center absolute bottom-5 right-5 left-8 font-semibold">
                        Read more
                        <span class="flex items-center justify-center size-12 ml-auto border-2 border-lime rounded-lg transition-colors group-hover:bg-lime">
                            <svg class="size-3"><use xlink:href="#icon-chevron-right" class="fill-green"></use></svg>
                        </span>
                    </div>
                </a>
            </article>
        `).join('')}
    `;
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
